import store from "./index.js";


export const actions = {
	search({commit},key){
		axios.get(api.blurredQuery+key.key).then(function(res){
			commit("SEARCH",res.data)
		}).catch(function(err){
			if(err.data.CODE == 404){
				console.log("模糊搜索---资源无法找到")
			}
			store.state.alreadyClick = false;
            store.state.item = []
            store.state.showlist=true;
		})
	},
	individualsearch({commit},key){
		axios.get(api.blurredQuery+key.key+"&type="+key.type).then(function(res){
			commit("INDIVIDUALSEARCH",res.data)
		}).catch(function(err){
			if(err.data.CODE == 404){
				console.log("模糊搜索---资源无法找到")
			}
			store.state.alreadyClick = false;
            store.state.item = []
            store.state.showlist=true;
		})
	}
}



// WEBPACK FOOTER //
// ./src/store/actions.js